export default function myReportsDirective() {
  return {
    template: require('./my-reports.html'),
    controller: 'MyReportsController',
    controllerAs: 'myReportsVM',
    bindToController: true,
    replace: true,
  };
}
